module.exports = __webpack_public_path__ + "kedar-1da81aa7c9849f667b68.jpeg";